import type { ProviderNavigationState } from './ProviderNavigationContextTypes';

export const createDefaultProviderNavigationState = (): ProviderNavigationState => ({
  sections: [],
  activeSection: null,
  branding: {
    name: null,
    logoUrl: null,
    slug: null,
  },
});
